import { List, Tooltip } from 'antd';
import React from 'react';
import { ObterComentarioPorMedicaoId, DownloadAnexoLinhaMedidas } from '@app/api/boletimMedicao';
import { usePromise, Button, Icon } from '@digital/ui';
import { convertUTCtoLocal } from '@app/helpers/dateTimeFormats';
import moment from 'moment';

export default function ListMensagem(linhaMedicaoId: any) {
  const [getAllMensagem] = usePromise(
    () =>
      linhaMedicaoId.linhaMedicaoId
        ? ObterComentarioPorMedicaoId(linhaMedicaoId.linhaMedicaoId)
        : Promise.resolve(undefined),
    [linhaMedicaoId.recarregarMensagem],
    [],
  );

  return (
    <div>
      <List
        itemLayout="horizontal"
        dataSource={getAllMensagem}
        renderItem={item => (
          <List.Item>
            {item.possuiArquivo ? (
              <List.Item.Meta
                title={
                  <a href="#">
                    {item.nomeDoUsuario + ' - ' + convertUTCtoLocal(moment(item.dataHoraInclusao)).toLocaleString()}
                  </a>
                }
                description={
                  <>
                    {item.mensagem}
                    <br />
                    <Button
                      type="link"
                      icon="arrows-circled_down_2"
                      onClick={() => {
                        DownloadAnexoLinhaMedidas(item.id);
                      }}>
                      Baixar Arquivo
                    </Button>
                  </>
                }
                className={item.mrn ? 'classeMrn' : 'classeFornecedor'}
              />
            ) : (
              <List.Item.Meta
                title={
                  <a href="#">
                    {item.nomeDoUsuario + ' - ' + convertUTCtoLocal(moment(item.dataHoraInclusao)).toLocaleString()}
                  </a>
                }
                description={item.mensagem}
                className={item.mrn ? 'classeMrn' : 'classeFornecedor'}
              />
            )}
          </List.Item>
        )}
      />
    </div>
  );
}
